import DragElement from "./DragElement";

export default class DragOption extends DragElement {
  dragType = "Drag";
}
